export default function Nopage(){
  return(
      <div className="row justify-content-center align-items-start g-2 mt-3">
          <div className="col-7">
            404
          </div>
      </div>
      
  )
}